export const classes = {
  wrapper: 'flex w-full justify-between items-start gap-2',
  title: 'text-[13px] font-bold text-taupe-3 dark:text-mauve-1 mr-[7px]',
  timestamp: 'text-[11.5px] font-medium text-taupe-1 dark:text-mauve-3',
  optionsWrapper: 'options-wrapper flex justify-center items-start ml-3',
  optionsIcon: 'cursor-pointer text-taupe-1 dark:text-mauve-3',
};
